import { controls, currencyToNumber, grouped } from "../../controls";

const branch_suggestion_status = {
  label: "Branch Suggestion Status",
  starting: true,
  url: "branch_suggestion_status",
  pageLabel: "Branch Suggestion Status",
  pageType: "history",
  visitingBranches: true,
  filter: [

    ...controls.displayText({ label: "Branch Code", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "EX(0002)", name: "branch_code", width: "col-sm-2" }),
    // ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    // ...controls.magicDateLabel({ tab: "general", label: "From Date", target: "from_date" }),
    // ...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype", isRequired: true }),
    // ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    // ...controls.magicDateLabel({ tab: "general", label: "To Date", target: "to_date" }),
    // ...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype", isRequired: true }),
    // ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Branch Suggestion Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    extraRows: {
      location: "top",
      fields: ["suggestion_given", "suggested_amount", "remain_count", "remain_amount"],
      grandtotal: { type: "fixed", displayIn: "branch_display", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Branch",
        accessor: "branch_display",
        rwidth: "*"
      },
      {
        Header: "Suggested Count",
        accessor: "suggestion_given"
      },
      {
        Header: "Suggested Amount",
        accessor: "suggested_amount"
      },
      {
        Header: "Remain Count",
        accessor: "remain_count"
      },
      {
        Header: "Remain Amount",
        accessor: "remain_amount"
      },
    ]
  }
};

export default branch_suggestion_status;